import { assocPath } from 'ramda';

import constants from '../constants';
import { Action } from 'edocatbase/Global';
var hasTouchScreen = false;

var UA = navigator.userAgent;
		hasTouchScreen = (
			/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
			/\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
		);
export type LoginReducer = {
  form: {
    username: string;
    password: string;
  };
  logoPath: string;
  loginPath: string;
  error: string;
  errors: {
    username: boolean;
    password: boolean;
  };
  processing: boolean;
  redirecting: boolean;
  readyToSubmit: boolean;
  isMobileDevice: boolean;
};

export const initialState = {
  form: {
    username: '',
    password: '',
  },
  logoPath: '',
  loginPath: '',
  error: '',
  errors: {
    username: false,
    password: false,
  },
  processing: false,
  redirecting: false,
  readyToSubmit: false,
  isMobileDevice: hasTouchScreen,
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case constants.ON_CHANGE: {
      const { name, value } = action.payload;
      return {
        ...state,
        error: false,
        errors: {
          ...state.errors,
          [name]: false,
        },
        form: {
          ...state.form,
          [name]: value,
        },
      };
    }

    case constants.HIGHLIGHT_ERRORS: {
      const { errors, name } = action.payload;
      if (name) {
        return assocPath(['errors', name], errors, state);
      } else {
        return {
          ...state,
          errors,
        };
      }
    }

    case constants.PROMISE_SUBMIT_START: {
      return {
        ...state,
        processing: true,
        error: '',
      };
    }

    case constants.PROMISE_SUBMIT_ERROR: {
      return {
        ...state,
        processing: false,
        error: 'fail',
        redirecting: false,
        form: {
          ...state.form,
          password: '',
        },
      };
    }

    case constants.PROMISE_SUBMIT_SUCCESS: {
      window.location.reload();

      return {
        ...state,
        error: '',
        processing: false,
        redirecting: true,
      };
    }

    case constants.SET_READY_TO_SUBMIT: {
      return {
        ...state,
        setReadyToSubmit: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
